const formatIdFromLabel = (label: string): string =>
    label
        .toLowerCase()
        .replaceAll(/\s+/g, '-') // Replace one or more spaces with hyphens
        .replaceAll(/[^a-z0-9-]/g, '') // Remove any non-alphanumeric characters except hyphens
        .replaceAll(/-+/g, '-') // Replace multiple consecutive hyphens with single hyphen
        .replaceAll(/(^-|-$)/g, ''); // Remove leading/trailing hyphens

export { formatIdFromLabel };
